import { Navigate, useLocation } from 'react-router'
import { SETTINGS } from '../../constants/routes'

const ProtectedRoute = ({ component: Component }) => {
  const location = useLocation()
  const hasContext = !!location.key && !location.state?.firstPage

  return hasContext ? <Component /> : <Navigate to={SETTINGS} replace />
}

export default ProtectedRoute
